import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import OutlinedInput from '@mui/material/OutlinedInput';
import { styled } from '@mui/system';

// import logo from './logo.svg';
// import './App.css';
import CssBaseline from '@mui/material/CssBaseline';

import {useAuth} from '../../context/AuthContext'
import {IMotoBrand,IMotoAvRow,IMotoOrderProps} from '../PageInterfaces'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import SendIcon from '@mui/icons-material/Send';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

const FormGrid = styled(Grid)(() => ({
    display: 'flex',
    flexDirection: 'column',
  }));
  
const logoStyle = {
    width: '140px',
    height: '56px',
    marginLeft: '-4px',
    marginRight: '-8px',
  };



function Info(props:IMotoOrderProps) {
    let vhstatus = 'ONPRODUCTION'
    if( (props.moto) && (props.moto.CCCNVEHSTATUS))
    {
        if( parseInt(props.moto?.CCCNVEHSTATUS)> 3 && parseInt(props.moto?.CCCNVEHSTATUS)< 7 ) vhstatus = 'ONWAY'
        else if( parseInt(props.moto?.CCCNVEHSTATUS)=== 7 ) vhstatus = 'LANDED'
        else if( parseInt(props.moto?.CCCNVEHSTATUS)===8 || parseInt(props.moto?.CCCNVEHSTATUS)===9) vhstatus = 'AVAILABLE'
        else vhstatus = 'UNAVAILABLE'
    }
    else vhstatus = 'Unknown'
    return (
    <Stack spacing={2}>
        <Typography>{props.brand?.description}{', '}{props.moto?.COMNAME}{', '}{props.moto?.COLRCOD} </Typography>
        <Typography>{'X. Τιμή: '}{props.moto?.PRICEW} </Typography>
        <Typography>{'Status: '}{vhstatus} </Typography>
    </Stack>)
}

function MotoOrder(props:IMotoOrderProps) {

    const handlePostOrder = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        props.retcb('brandlist')
    }

    return(
        <>
        <CssBaseline />
        <Grid container sx={{ height: { xs: '100%', sm: '100dvh' } }}>


        {/* small mobile  <Grid item sm={12} md={7} lg={8}    */}
        <Grid size={{ sm: 12, md: 7, lg: 8 }}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '100%',
            width: '100%',
            backgroundColor: { xs: 'transparent', sm: 'background.default' },
            alignItems: 'start',
            pt: { xs: 2, sm: 4 },
            px: { xs: 2, sm: 10 },
            gap: { xs: 4, md: 8 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: { sm: 'space-between', md: 'flex-end' },
              alignItems: 'center',
              width: '100%',
              maxWidth: { sm: '100%', md: 600 },
            }}
          >
            <Box
              sx={{
                display: { xs: 'flex', md: 'flex' },
                flexDirection: 'row',
                width: '100%',
                justifyContent: 'space-between',
              }}
            >
              <Button variant="outlined" startIcon={<ArrowBackRoundedIcon />}
                onClick={ (e) => { props.retcb('brandlist')} }
                component="a" href="#" sx={{ alignSelf: 'start' }} >
                επιστροφη
               </Button>
              
            </Box>

          </Box>
          <Card
            sx={{
              display: { xs: 'flex', md: 'flex' },
              width: '100%',
            }}
          >
            <CardContent
              sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
                ':last-child': { pb: 2 },
              }}
            >
              {/* <div>
                <Typography variant="subtitle2" gutterBottom>
                  Selected products
                </Typography>
                <Typography variant="body1">
                  {'$144.97'}
                </Typography>
              </div> */}
              {/* <InfoMobile totalPrice={activeStep >= 2 ? '$144.97' : '$134.98'} /> */}
                <Info brand={props.brand} moto={props.moto} retcb={()=>{}} retstate='none' />
            </CardContent>
          </Card>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              width: '100%',
              maxWidth: { sm: '100%', md: 600 },
              maxHeight: '720px',
              gap: { xs: 5, md: 'none' },
            }}
          >
            <Box component="form"
                sx={{'& .MuiTextField-root': { m: 1, width: '100%' },  }}
                noValidate autoComplete="off" >
                <div>
                    <TextField id="ordercomments"
                        label="Σχόλια" multiline minRows={2}  maxRows={4} />
                </div>
            </Box>
            <Box component="form">
                <div>
                <Button variant="contained" endIcon={<SendIcon />}
                onClick={ (e) =>{handlePostOrder(e)}}>
                    αποστολη παραγγελιας
                </Button>
                </div>
            </Box>

          </Box>
        </Grid>

      </Grid>

      </>
    )
}
export default MotoOrder